var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.SiteSelectFeature = new Class({
    Implements: [Options, Events],
    options: {
        selectable_limit: 1,
        selected_id: null
    },
    layer: null,
    range_layer: null,
    select_obj: null,
    mouse_move_obj: null,
    bound_methods: {},
    initialize: function (options) {
        this.setOptions(options);
        this.bound_methods.on_selection_add = this.on_selection_add.bind(this);
        this.layer = new OCS.Viewer.Classes.DefaultLayer({"style_type":"point_select"});
        this.layer.create();
        var source = this.layer.create_point_source({ready_callback: this.on_source_ready_callback.bind(this), url: OCS.Viewer.Config.site_config_url});
        this.layer.set_source(source);
        this.select_obj = this.layer.add_select_feature_click({selectable_limit: this.options.selectable_limit});
        this.mouse_move_obj = this.layer.add_select_feature_mousemove();
        var selected_features = this.select_obj.getFeatures();
        selected_features.on('add', this.bound_methods.on_selection_add);
    },
    on_source_ready_callback: function () {
        var selected_features = this.select_obj.getFeatures();
        var source = this.layer.get_source();
        var feature = source.getFeatureById(this.options.selected_id);
        if (feature) {
            feature.set('selected', true);
            if (this.options.debug) {
                console.log('map_manager ' + this.map_selector + ': found feature! ' + this.options.selected_id);
            }
            selected_features.push(feature);
        }
    },

    on_selection_add: function (event) {
        if (event.element.get('ID') !== this.options.selected_id) {
            this.fireEvent('selected', [{'id': event.element.get('ID'), 'name': event.element.get('NAME')}, true]);
        }
    },

});